module.exports = __webpack_public_path__ + "img/logo-big.9d4be0d8.png";